export default function Header() {
  return (
    <header className="header">
      <h1 style={{ color: "#fff" }}>CLP</h1>
    </header>
  );
}
